<template>
  <v-flex>
    <v-flex xs12 sm6>
      <v-text-field
        v-model="name"
        :label="placeholders.name"
        :placeholder="placeholders.name"
        color="rgb(135, 0, 0)"
        single-line
        flat
      ></v-text-field>
    </v-flex>
    <!-- EMAIL -->
    <v-flex xs12 sm6>
      <v-text-field
        v-model="email"
        :rules="isSimple ? [] : isEmpty"
        :label="placeholders.email"
        :placeholder="placeholders.email"
        color="rgb(135, 0, 0)"
        single-line
        flat
        required={!isSimple}
      ></v-text-field>
    </v-flex>
    <!-- PHONE NO -->
    <v-flex xs12 sm6 v-if="!isSimple">
      <v-text-field
        v-model="phone"
        :label="placeholders.phone"
        :placeholder="placeholders.phone"
        color="rgb(135, 0, 0)"
        single-line
        flat
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 v-if="isSimple">
      <v-text-field
        v-model="link"
        :label="placeholders.link"
        :placeholder="placeholders.link"
        color="rgb(135, 0, 0)"
        single-line
        flat
        required
      ></v-text-field>
    </v-flex>

  </v-flex>
</template>

<script>
import { fromStore } from '../util'

export default {
  name: 'LayoutQuestions',
  props: {
    lang: String,
    placeholders: Object,
    isSimple: Boolean
  },
  data: () => ({
    isEmpty: [
      v => !!v || 'Cannot be empty'
    ]
  }),
  computed: {
    name: fromStore('name'),
    email: fromStore('email'),
    phone: fromStore('phone'),
    link: fromStore('link')
  }
}
</script>

<style scoped>

</style>
